import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';

/**
 * Homepage closing call-to-action band.
 */
export default class HomeCta extends Component {
  view() {
    return m("section", {
      className: "HomeSection"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "HomeCta"
    }, m("div", null, m("h2", null, app.translator.trans('glowingblue-demo.forum.home.cta.heading')), m("p", null, app.translator.trans('glowingblue-demo.forum.home.cta.lead'))), m(Button, {
      className: "Button Button--primary",
      onclick: IndexSidebar.prototype.newDiscussionAction.bind(IndexSidebar.prototype)
    }, m("i", {
      className: "fas fa-pen Button-icon"
    }), ' ', m("span", {
      className: "Button-label"
    }, app.translator.trans('glowingblue-demo.forum.home.cta.button'))))));
  }
}
flarum.reg.add('glowingblue-demo', 'forum/components/home/HomeCta', HomeCta);